"use client";
import { useEffect } from 'react';

export function GlobalErrorHandler() {
  useEffect(() => {
    window.onerror = function (message, source, lineno, error) {
      console.error("[Erro capturado]:", { message, source, lineno, error });
      return true;
    };

    window.addEventListener('unhandledrejection', (event) => {
      console.error("[Erro de Promise]:", event.reason);
      event.preventDefault();
    });

    const handleError = (error: ErrorEvent | PromiseRejectionEvent) => {
      const errorMessage = error instanceof PromiseRejectionEvent
        ? String(error.reason?.message || error.reason)
        : error.message;

      if (/Loading chunk [\d]+ failed/.test(errorMessage) ||
        /Failed to fetch dynamically imported module/.test(errorMessage)) {
        console.error('Chunk load error detected, attempting recovery...');

        setTimeout(() => {
          if (!window.location.hash) {
            window.location.reload();
          } else {
            window.location.href = window.location.pathname;
          }
        }, 1000);
      }
    };

    window.addEventListener('error', handleError as EventListener);
    window.addEventListener('error', handleError);
    return () => {
      window.onerror = null;
      window.removeEventListener('unhandledrejection', handleError);
      window.removeEventListener('error', handleError as EventListener);
    };
  }, []);

  return null;
}